import { useEffect, useState } from "react";
import { useAuth } from "../context/AuthContext";
import api from "../services/api";
import "../styles/perfil.css";
import Swal from "sweetalert2";

export default function PerfilEditable() {
  const { token } = useAuth();
  const [perfil, setPerfil] = useState(null);
  const [form, setForm] = useState({
    nombre: "",
    email: "",
    dni: "",
    categoria: "",
    ciudad: "",
    genero: "",
    puntos: "" // Agregamos puntos al estado inicial
  });
  const [mensaje, setMensaje] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    if (token) {
      api.get("/perfil", {
        headers: { Authorization: `Bearer ${token}` }
      })
        .then(res => {
          setPerfil(res.data);
          setForm({
            nombre: res.data.nombre || "",
            email: res.data.email || "",
            dni: res.data.dni || "",
            categoria: res.data.categoria || "",
            ciudad: res.data.ciudad || "",
            genero: res.data.genero || "",
            puntos: res.data.puntos || "", // Cargamos puntos desde la respuesta
            celular: res.data.celular || ""
          });
        })
        .catch(err => {
          console.error("Error al obtener perfil:", err);
          setError("No se pudo cargar la información del perfil.");
        });
    }
  }, [token]);

  const handleChange = e => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setMensaje("");
    setError("");
    try {
      await api.put("/perfil", form, {
        headers: { Authorization: `Bearer ${token}` }
      });


      Swal.fire({        title: "¡Perfil Actualizado!",
        text: "Tus datos han sido actualizados exitosamente.",
        icon: "success",
        confirmButtonText: "Aceptar"
      });
    } catch (err) {
      console.error("Error al actualizar perfil:", err);
      setError("Error al actualizar los datos. Intenta nuevamente.");
    }
  };

  if (!perfil) return <p style={{ textAlign: "center" }}>Cargando perfil...</p>;

  return (
    <div className="perfil-container">
      <h1 className="perfil-title">PERFIL</h1>
      <h2 className="perfil-subtitle">Actualiza tus datos</h2>
      {error && <p style={{ color: "red", textAlign: "center" }}>{error}</p>}
      <form className="perfil-form" onSubmit={handleSubmit}>
        <div className="perfil-row">
          <div>
            <label>Nombre</label>
            <input name="nombre" value={form.nombre} onChange={handleChange} />
          </div>
          <div>
            <label>Email</label>
            <input name="email" value={form.email} onChange={handleChange} />
          </div>
          <div>
            <label>Celular</label>
            <input name="celular" value={form.celular} onChange={handleChange} />
          </div>
        </div>
        <div className="perfil-row">
          <div>
            <label>DNI</label>
            <input name="dni" value={form.dni} onChange={handleChange} />
          </div>
          <div>
            <label>Ciudad</label>
            <input name="ciudad" value={form.ciudad} onChange={handleChange} />
          </div>
        </div>
        <div className="perfil-row">
          <div>
            <label>Género</label>
            <select
              name="genero"
              value={form.genero}
              onChange={e => setForm({ ...form, genero: e.target.value, categoria: "" })}
              required
            >
              <option value="">Selecciona género</option>
              <option value="Libres">Caballeros (Libres)</option>
              <option value="Damas">Damas</option>
            </select>
          </div>
          <div>
            <label>Categoría</label>
            <input type="text" name="categoria" value={form.categoria} disabled />
          </div>
        </div>
        <div className="perfil-row">
          <div>
            <label>Puntos</label>
            <input name="puntos" value={form.puntos} disabled /> {/* Campo solo lectura */}
          </div>
        </div>
        <button className="perfil-btn" type="submit">Actualizar datos</button>
        {mensaje && <p style={{ color: "green", textAlign: "center" }}>{mensaje}</p>}
      </form>
      
    </div>
  );
}